module.exports = __webpack_public_path__ + "img/sports-tennis.f0e7addf.svg";